import { isInWebView } from '@shared/george-go';
import { logger } from '@luna/logger';
import type { AppearanceMode } from '@shared/dark-mode-utils';

import { saveAppearanceMode, useDarkModeState } from './darkModeSlice';

type DarkModePreferenceUpdater = (userPreference: AppearanceMode) => Promise<void>;

type InitDarkModeParams = {
    isDarkModeSupported?: boolean;
    currentUserPreference?: AppearanceMode;
    updateUserPreference?: DarkModePreferenceUpdater;
};

const uninitializedDarkModePreferenceMutator: DarkModePreferenceUpdater = () => {
    const uninitializedErrorMessage = 'Please set up dark mode updater for this application.';
    logger.error(uninitializedErrorMessage);
    throw new Error(uninitializedErrorMessage);
};

let darkModePreferenceUpdater: DarkModePreferenceUpdater = uninitializedDarkModePreferenceMutator;

export function updateDarkModePreference(userPreference: AppearanceMode): Promise<void> {
    return darkModePreferenceUpdater(userPreference);
}

export function initDarkMode({
    currentUserPreference,
    updateUserPreference,
    isDarkModeSupported = true,
}: InitDarkModeParams): void {
    if (!isDarkModeSupported) {
        saveAppearanceMode('LIGHT');
    } else if (isInWebView()) {
        saveAppearanceMode('SYSTEM');
    } else {
        saveAppearanceMode(currentUserPreference ?? 'LIGHT');
    }

    if (updateUserPreference) {
        darkModePreferenceUpdater = updateUserPreference;
    }
}

export function getGeorgeTheme(): 'dark' | 'light' {
    return useDarkModeState.getState().isActive ? 'dark' : 'light';
}
